import styled from 'styled-components';

import { Checkbox } from '../styled';
import { MultiInput } from './multi-input';

const ICON_SIZE = 32;
const ICON_OVERLAP = 4;

const Circle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.color};
  border: 2px solid #fff;
  color: #fff;
  font-weight: bold;
  box-sizing: border-box;
  flex: none;
  width: ${ICON_SIZE}px;
  min-width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
  min-height: ${ICON_SIZE}px;
  padding: 0;
  line-height: 1;
  border-radius: 50%;
  overflow: hidden;
  white-space: nowrap;
  font-size: 12px;
`;

const ValueContent = styled.ul`
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  height: 100%;
  li {
    list-style: none;
    position: relative;
    display: flex;
    flex: none;
    & + li {
      margin-left: -${ICON_OVERLAP}px;
    }
  }
`;

const More = styled.li`
  margin-left: 6px !important;
  font-size: 14px;
  white-space: nowrap;
  b {
    margin-left: 8px;
  }
`;

const Value = ({ values, maxValuesShow = 1 }) => {
  const shown = values.slice(0, maxValuesShow);

  return (
    <ValueContent>
      {shown.map((item) => (
        <li key={item.id}>
          <Circle color={item.color}>{item.name}</Circle>
        </li>
      ))}
      {values.length > maxValuesShow && <More>
          ...<b>{values.length}</b>
        </More>}
    </ValueContent>
  );
};

const Item = (props) => {
  const { onChange, name, checked, color } = props;

  return (
    <Checkbox className="checkbox">
      <input onChange={onChange} type="checkbox" name={name} checked={checked} />
      <Circle color={color}>{name}</Circle>
    </Checkbox>
  );
};

/**
 * data - {id: string, name: string, ...}
 * maxValuesShow - max number of selected zones shown, the rest is replaced with "... <total>"
 */
export const ZoneInput = (props) => {
  return <MultiInput {...props} itemCmp={Item} valueCmp={Value} className="width-auto" />;
};

// width of the input box needed for the icons that are actually shown (plus the "... N" tail when some are hidden)
ZoneInput.getMinWidth = ({ maxValuesShow = 1, values = [] }) => {
  const shown = Math.max(1, Math.min(values.length, maxValuesShow));
  const tail = values.length > maxValuesShow ? 38 : 0;

  return 9 + 30 + ICON_SIZE + (shown - 1) * (ICON_SIZE - ICON_OVERLAP) + tail;
};
